import { EPaymentType } from '../enums/payment-type.enum';

export const paymentTypeOptions = [
    { value: EPaymentType.DEBIT, label: 'Débito' },
    { value: EPaymentType.CREDIT, label: 'Crédito' },
    { value: EPaymentType.PIX, label: 'PIX' },
    { value: EPaymentType.BOLETO, label: 'Boleto' },
    { value: EPaymentType.PERMUTA, label: 'Permuta' },
    { value: EPaymentType.GRATIS, label: 'Grátis' },
];
